<div class="backg"></div>

<app-breadcrumbs
  [segments]="[{ label: breadcrumbLabel , routerLink: '/glossario' }]"
></app-breadcrumbs>

<div class="container">
  <h3 class="text-primary fw-bold mb-4" i18n="@@glossary-page.list-title-text">Glossario</h3>
  <div
    class="d-flex flex-row flex-md-column-reverse justify-content-end"
  >
    <app-glossary-entry
      *ngIf="(glossaryEntries$ | async) as glossaryEntries"
      class="flex-grow-1 flex-md-grow-0 me-4 me-md-0"
      [entries]="glossaryEntries"
    ></app-glossary-entry>

    <div *ngIf="(loading$ | async)" class="text-primary">
      <app-spinner></app-spinner>
    </div>

    <app-alphabet-selector
      [selectedCharacter]="selectedCharacter"
      [availableChars]="availableChars$ | async"
      (characterSelected)="characterSelectedHandler($event)"
    ></app-alphabet-selector>
  </div>
</div>
